module.exports = __webpack_public_path__ + "media/images/athletes/478-6a73fb15935a30674cafe315f26a43c1.png";